<section id="contact">
  <div class="header-title">
    <h1 i18n="Contact Title|Title for Contact Page@@TitleContact">Contact</h1>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 25 1440 200">
      <path fill="#ffffff" fill-opacity="1" d="M0,128L80,122.7C160,117,320,107,480,122.7C640,139,800,181,960,181.3C1120,181,1280,139,1360,117.3L1440,96L1440,320L1360,320C1280,320,1120,320,960,320C800,320,640,320,480,320C320,320,160,320,80,320L0,320Z"></path>
    </svg>
  </div>

    <div class="container">
      <div class="row" wmAnimate="bounceIn" delay="1000" aos>
        <div class="col-md-5">
          <h2 i18n="Contact Intro|Intro for Contact Page@@IntroContact">Want to work with me?<br>Tell me about your project.</h2>
          <p><i class="fa fa-map-marker" aria-hidden="true"></i> Israel</p>
          <p><i class="fa fa-envelope" aria-hidden="true"></i> atoyansk.work@gmail.com</p>
        </div>
        <div class="col-md-7">
          <form [formGroup]="f" (ngSubmit)="submit()">
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label for="name" i18n="Name Label|Label to Name@@NameLabel">Name</label>
                  <input type="text" class="form-control" id="name" placeholder="Your Name" i18n-placeholder="Name placeholder|Name placeholder@@namePlaceholder" formControlName="name" [ngClass]="{ 'is-invalid': submitted && fr.name.errors }">
                  <div *ngIf="submitted && fr.name.errors" class="invalid-feedback">
                    <div *ngIf="fr.name.errors.required" i18n="Name Required|Label to Name is required@@NameReq">Name is required</div>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label for="email" i18n="Email Label|Label to Email@@EmailLabel">Email</label>
                  <input type="email" class="form-control" id="email" placeholder="Your Email" i18n-placeholder="Email placeholder|Email placeholder@@emailPlaceholder" formControlName="email" [ngClass]="{ 'is-invalid': submitted && fr.email.errors }">
                  <div *ngIf="submitted && fr.email.errors" class="invalid-feedback">
                    <div *ngIf="fr.email.errors.required" i18n="Email Required|Label to Email is required@@EmailReq">Email is required</div>
                    <div *ngIf="fr.email.errors.email" i18n="Email Valid|Label to Email is valid@@EmailValid">Email must be a valid email address</div>
                </div>
                </div>
              </div>
            </div>

            <div class="form-group">
              <label for="message" i18n="Message Label|Label to Message@@MessageLabel">Message</label>
              <textarea class="form-control" id="message" placeholder="Your Mesage or Project Description" i18n-placeholder="Msg placeholder|Msg placeholder@@msgPlaceholder" rows="5" formControlName="message" [ngClass]="{ 'is-invalid': submitted && fr.message.errors }"></textarea>
              <div *ngIf="submitted && fr.message.errors" class="invalid-feedback">
                <div *ngIf="fr.message.errors.required" i18n="Message Required|Label to Message is required@@messageReq">Message is required</div>
              </div>
            </div>
            <div class="col-md-12">
              <button class="btn btn-success btn-outline-rounded" type="submit" i18n="Send Button|Label to send data@@Send">Send</button>
            </div>
            
          </form>
        </div>
      </div>

    </div>
  </section>
